import axios from "axios";
import { IGeoLocationAddress } from "../declarations";
import { useQuery } from "@tanstack/react-query";

const GetGeoLocationAddress = async (
    lat: number,
    long: number,
): Promise<IGeoLocationAddress> => {
    const response = await axios.get<IGeoLocationAddress>(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(long)}`,
    );
    return response.data;
};

export const useGetGeoLocationAddress = (lat: number, long: number) =>
    useQuery<IGeoLocationAddress | null>({
        queryKey: ["GetGeoLocationAddress", lat, long],
        queryFn: () => {
            return GetGeoLocationAddress(lat, long);
        },
        enabled: lat !== 0 && long !== 0,
        refetchOnWindowFocus: false,
        retry: false,
        placeholderData: null,
    });
